import React, { useState,useRef,useEffect } from "react";
import { useTranslation } from "react-i18next";
import { formatToLocalDateTime } from "../utils/formatDate";
import Loader from "../../../components/Loader";
import edit from "../../../assets/edit.png";
import URL_MAPPING from "../../../routes/constants";
import { useNavigate } from "react-router-dom";
import { CustomModal } from "./CustomModal";
import { toast, ToastContainer } from "react-toastify";
import { deleteRoles } from "../api/auth";
interface AdminTableProps {
  tableData: any;
  loading: boolean;
  refetch: boolean;
  handleEditEmoloyee: (id: string) => void;
   setRefetch: React.Dispatch<React.SetStateAction<boolean>>;
}
const RolePermissionsAuthTable: React.FC<AdminTableProps> = ({
  tableData,
  loading,
  handleEditEmoloyee,
  refetch,
  setRefetch
}) => {
  const { t } = useTranslation();
    const [menuOpen, setMenuOpen] = useState<number | null>(null);
    const [isOpen, setIsOpen] = useState(false);
    const [selectedItemId, setSelectedItemId] = useState<number | null>(null);
    const toggleMenu = (index: number) => {
      if (index) setMenuOpen(index);
    };
      const navigate = useNavigate();
    const dropdownRef = useRef<HTMLDivElement | null>(null);
         useEffect(() => {
            const handleClickOutside = (event: MouseEvent) => {
              if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setMenuOpen(null); // Close menu
              }
            };
          
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
              document.removeEventListener("mousedown", handleClickOutside);
            };
          }, []);
          const handleModalActivity = () => {
            setIsOpen(!isOpen);
          };
        
          const handleEditOffer = () => {
            if (menuOpen === null) return;
            navigate(URL_MAPPING.ADDPERMISSIONS(String(menuOpen)));
          };

          const handlePermissions = () => {
            if (menuOpen === null) return;
            navigate(URL_MAPPING.EDITPERM(String(menuOpen)));
          };

            const handleDeleteMapping = async () => {
              try {
                if (selectedItemId === null) {
                  toast.error("No id selected for deletion");
                  return;
                }
                const response = await deleteRoles(selectedItemId);
                if (!response) {
                  toast.error("No data received or malformed response");
                  console.warn("No data received or malformed response:", response);
                  return;
                }
                toast.success(response?.message);
                handleModalActivity();
                setRefetch(!refetch);
              } catch (error: any) {
                console.error("Failed to fetch  data:", error);
                if (error?.response?.status === 404) {
                  toast.error((error?.response?.data?.detail) || "Please try again later");
                } else if (error?.response?.status === 500) {
                  toast.error("Error while fetching the employee");
                } else {
                  const detail = error?.response?.data?.detail;
                  if (Array.isArray(detail)) {
                    detail.forEach((err) => toast.error(err.msg));
                  } else {
                    toast.error(detail?.msg || detail || "An unexpected error occurred.");
                  }
                }
              }
            };
  return (
    <>
    
      <ToastContainer />
     <CustomModal
            isOpen={isOpen}
            onClose={handleModalActivity}
            onDelete={handleDeleteMapping}
          />
    <div className="h-[65vh] md:h-[67vh] overflow-auto page-container p-2 pt-0 scrollbar scrollbar-thin">
      <table className="min-w-full bg-white border border-black-200 table-auto border-separate border-spacing-0">
        <thead className="bg-gray-200 sticky top-[0px] z-20">
          <tr>
            <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-nowrap">
      Role ID
            </th>
            <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500">
            Role Name
            </th>
            <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
         Channel Name
            </th>
       
           
            <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500">
            Channels
            </th>
            <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500">
            Sales Offices
            </th>
            <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500">
            Updated at
            </th>
            
            <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500">
              Actions
            </th>
          </tr>
        </thead>
        {loading ? (
          <tbody>
            <tr>
              <td colSpan={16} className="py-8">
                <div className="flex justify-center items-center w-full">
                  <Loader />
                </div>
              </td>
            </tr>
          </tbody>
        ) : !loading && tableData?.items?.length === 0 ? (
          <tr>
            <td colSpan={16} className="py-8 text-center text-gray-500">
              No results found
            </td>
          </tr>
        ) : (
          <tbody>
            {Array.isArray(tableData?.items) &&
              tableData.items.map((item: any, index: number) => (
                <tr key={index} className="border-b text-sm">
                  <td className="border border-gray-300 px-4 py-2">{item.id || "-"}</td>
                  <td className="border border-gray-300 px-4 py-2">{item.role_name || "-"}</td>
                  <td className="border border-gray-300 px-4 py-2">{item.channel_names || "-"}</td>
             
          


                 
                  <td className="border border-gray-300 px-4 py-2">
                    {item.channels || "-"}
                  </td>
                  <td className="border border-gray-300 px-4 py-2">
                    {item.sales_offices || "-"}
                  </td>
                  
                  <td className="border border-gray-300 px-4 py-2">
                    {formatToLocalDateTime(item.updated_at) || "-"}
                  </td>
                  <td className="border border-gray-300 px-4 py-2 text-center relative">
                      <button
                        onClick={() => toggleMenu(item.id)}
                        className="text-gray-500 hover:text-gray-800"
                      >
                        <p className="text-lg">⋮</p>
                      </button>
                      {menuOpen === item.id && (
                        <div
                        ref={dropdownRef}
                          className={`absolute right-10 -mt-5 w-32 bg-white border border-gray-200 shadow-lg rounded z-10 text-left`}
                        >
                          <ul className="py-1 text-sm text-gray-900">
                            {/* <li
                              className="px-4 py-2 hover:bg-gray-200 cursor-pointer"
                              onClick={() => 
                              {
                                setSelectedItemId(item.id); 
                                handleEditOffer()}}
                            >
                       Assign Permissions
                            </li> */}
                            <li
                              className="px-4 py-2 hover:bg-gray-200 cursor-pointer"
                              onClick={() => 
                              {
                                setSelectedItemId(item.id); 
                                handlePermissions()}}
                            >
                     Update
                            </li>
                            {/* <li
                              className="px-4 py-2 hover:bg-gray-200 cursor-pointer"
                              onClick={() => {
                                setSelectedItemId(item.id);  // set for modal
                                handleModalActivity();
                              }}
                            >
                              Delete
                            </li> */}
                          </ul>
                        </div>
                      )}
                    </td>
                </tr>
              ))}
          </tbody>
        )}
      </table>
    </div>
    </>
  );
};

export default RolePermissionsAuthTable;
